import React from "react";

export function WorkflowRunMarker({ currentWorkflow, onDismiss }) {
  if (!currentWorkflow) return null;
  const { name, params, phase } = currentWorkflow;
  const paramEntries = Object.entries(params || {});
  // Default to "completed" so callers that pre-date the phase field (and
  // tests that set currentWorkflow directly) don't show a stuck "running"
  // banner — the marker reads as origin metadata, not a live status.
  const isRunning = phase === "running";
  const prefix = isRunning
    ? `▶ Running workflow: "${name}"`
    : `Started from workflow: "${name}"`;
  return (
    <div className="copilot-workflow-run-marker">
      <span className="copilot-workflow-run-marker__text">
        <span>{prefix}</span>
        {paramEntries.length > 0 && (
          <span>
            {" with "}
            {paramEntries.map(([k, v], i) => (
              <span key={k}>
                {i > 0 ? ", " : ""}
                {k}="{v}"
              </span>
            ))}
          </span>
        )}
      </span>
      {onDismiss && (
        <button
          type="button"
          className="copilot-workflow-run-marker__close"
          aria-label="Dismiss workflow banner"
          title="Dismiss"
          onClick={onDismiss}
        >
          ×
        </button>
      )}
    </div>
  );
}
